<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Logística</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
                    </div>
                    <div>
                        <v-btn type="button" outlined color="primary" elevation="0" class="mr-2"
                            to="/logistica/importar">
                            <v-icon left small>mdi-table-arrow-down</v-icon>Importar planilha</v-btn>
                        <v-btn type="button" outlined color="primary" elevation="0" class="mr-2"
                            @click="generateSchedule" :loading="schedule.loading"
                            :disabled="loading || !dataList.data.some(i => i.vehicle_number > 0)">
                            <v-icon left small>mdi-clock-fast</v-icon>Gerar horários</v-btn>
                        <v-btn id="btnSaveChanges" type="button" color="primary" elevation="0" class="mr-2"
                            @click="saveChanges" :disabled="loading">Salvar Alterações</v-btn>
                        <v-btn id="btnReviewTrip" type="button" color="success" elevation="0" @click="openReviewModal"
                            :disabled="loading || dataList.data.length === 0">Revisar Viagem</v-btn>
                        <v-btn id="btnResetData" type="button" outlined color="primary" elevation="0" class="ml-2"
                            @click="handleResetButtonClick" :disabled="loading"> {{ showSelectionCheckboxes
                                ? 'Excluir Selecionadas' : 'Resetar Dados' }}</v-btn>

                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined class="ml-2"
                            to="/monitoramento">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="loadInitialData()">
                            <v-row align="center">
                                <v-col>
                                    <v-text-field dense id="date" label="Data" v-model="dataList.filter.date"
                                        hide-details outlined type="date" clearable></v-text-field>

                                </v-col>
                                <v-col>
                                    <v-text-field dense id="date" label="Hora" v-model="dataList.filter.time"
                                        hide-details outlined type="time" clearable></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field dense id="itinerary" label="Itinerário"
                                        v-model="dataList.filter.itinerary" hide-details outlined
                                        clearable></v-text-field>
                                </v-col>

                                <v-col>
                                    <v-text-field dense id="passenger" label="Passageiro"
                                        v-model="dataList.filter.passenger" hide-details outlined
                                        clearable></v-text-field>
                                </v-col>

                                <v-col>
                                    <v-text-field dense id="requester" label="Solicitante"
                                        v-model="dataList.filter.requester" hide-details outlined
                                        clearable></v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-select no-data-text="Nenhum tipo encontrado" dense :items="dataset.tripTypes"
                                        label="Tipo" v-model="dataList.filter.type" item-value="id" item-text="name"
                                        outlined hide-details="auto" clearable>
                                    </v-select>
                                </v-col>

                                <v-col>
                                    <v-text-field dense id="customer" label="Empresa" v-model="dataList.filter.customer"
                                        hide-details outlined clearable></v-text-field>
                                </v-col>

                                <v-col>
                                    <v-combobox v-model="dataList.filter.neighborhoods" label="Bairros" dense outlined
                                        multiple chips small-chips deletable-chips hide-details clearable
                                        :delimiters="[',', ';']" @change="normalizeTags('neighborhoods')" />
                                </v-col>

                                <v-col>
                                    <v-combobox v-model="dataList.filter.cities" label="Cidades" dense outlined multiple
                                        chips small-chips deletable-chips hide-details clearable
                                        :delimiters="[',', ';']" @change="normalizeTags('cities')" />
                                </v-col>

                                <v-col sm="2" class="d-flex align-center flex-nowrap">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                    <v-btn class="ml-2" id="btnFilter" @click="dataList.filter = {}" color="primary"
                                        dark outlined elevation="2">Limpar</v-btn>
                                </v-col>
                            </v-row>

                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table @update:items-per-page="pageSizeChanged" :headers="headers" :items="dataList.data"
                            :loading="dataList.loading" no-data-text="Nenhuma viagem pendente encontrada"
                            loading-text="Carregando viagens..." class="app-table no-table-lines" disable-pagination
                            hide-default-footer :server-items-length="dataList.count" @update:options="onOptionsChange">
                            <template v-slot:footer>
                                <div class="pa-2 d-flex align-center justify-end">
                                    <span class="mr-2">Itens por página</span>
                                    <v-select :items="dataList.footerOptions.itemsPerPageOptions"
                                        v-model="dataList.options.itemsPerPage" dense outlined hide-details
                                        style="max-width: 110px" @change="pageSizeChanged" />
                                    <span class="ml-6">Mostrando <strong>{{ dataList.data.length }}</strong> de
                                        <strong>{{ dataList.count }}</strong></span>
                                </div>
                            </template>

                            <template v-slot:body="{ items, headers }">
                                <tbody>
                                    <template v-for="(item, index) in items">
                                        <!-- Linha principal -->
                                        <tr :key="`row-${item.id}`">
                                            <!-- Colunas do headers -->
                                            <td class="text-center">
                                                {{ item.date | defaultDate }} </br>
                                                {{ item.time }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.type | enum(dataset.tripTypes, 'id', 'name') }}
                                            </td>
                                            <td class="text-center text-uppercase">{{ item.passenger.name }}<br />
                                                <small><i>{{ item.cost_center ? (item.cost_center.name ||
                                                    item.cost_center.code) : (item.passenger.cost_center.name ||
                                                        item.passenger.cost_center.code) }}</i></small>
                                            </td>
                                            <td class="text-center text-uppercase">{{ item.itinerary_name }}</td>
                                            <td class="text-center text-uppercase">{{ item.requester ?
                                                item.requester.name : '-' }}</td>
                                            <td class="text-center text-uppercase">{{ item.passenger.customer.name }}
                                            </td>
                                            <td class="text-center" style="width:140px;">
                                                <v-text-field v-model="item.boarding_time" dense outlined hide-details
                                                    type="time" maxlength="6" class="my-2"
                                                    @blur="validateBoardingTime(item)" />
                                            </td>
                                            <td class="text-center" style="width:140px;">
                                                <v-text-field v-model.number="item.vehicle_number" type="number"
                                                    clearable dense outlined hide-details="auto" class="my-2"
                                                    @blur="validateVehicleNumber(item)" />
                                                <small v-if="item.transport_hint" class="d-block grey--text mb-2"
                                                    title="Transporte informado na planilha">{{ item.transport_hint }}</small>
                                            </td>

                                            <td class="text-center">
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-icon v-on="on" @click="openAppendTripDialog(item)"
                                                            size="large" class="mr-2">
                                                            mdi-car-clock
                                                        </v-icon>
                                                    </template>
                                                    <span>Adicionar passageiro em uma OS existente</span>
                                                </v-tooltip>

                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-icon v-on="on" @click="openRequestDetails(item)" size="large"
                                                            class="mr-2">
                                                            mdi-eye
                                                        </v-icon>
                                                    </template>
                                                    <span>Visualizar detalhes</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>

                                        <!-- Footer sempre visível -->
                                        <tr :key="`footer-${item.id}`" class="no-row-border">
                                            <td :colspan="headers.length + 1" class="pa-0">
                                                <v-sheet class="row-footer px-4 py-3"
                                                    :style="'border-left: 6px solid ' + routeColors[index % routeColors.length] + ' !important'">
                                                    <div class="footer-grid">
                                                        <div class="addresses">
                                                            <div class="addr-line"
                                                                @click="openInMaps(item.points[0].address)">
                                                                <v-icon left small>mdi-map-marker</v-icon>
                                                                <span class="label">De:</span>
                                                                <span class="addr-text"
                                                                    :title="(item.points && item.points[0] && item.points[0].address) || 'Endereço não informado'">
                                                                    {{ (item.points && item.points[0] &&
                                                                        item.points[0].address) || 'Endereço não informado'
                                                                    }}
                                                                </span>
                                                            </div>
                                                            <div class="addr-line" v-for="stop in (item.stops || [])"
                                                                :key="`req-stop-${item.id}-${stop.id}`"
                                                                @click="openInMaps(stop.address)">
                                                                <v-icon left small color="orange darken-2">mdi-map-marker-path</v-icon>
                                                                <span class="label">Parada {{ stop.position }}:</span>
                                                                <span class="addr-text" :title="stop.address">
                                                                    {{ stop.address }}
                                                                </span>
                                                            </div>
                                                            <div class="addr-line"
                                                                @click="openInMaps(item.points[1].address)">
                                                                <v-icon left small>mdi-flag-checkered</v-icon>
                                                                <span class="label">Para:</span>
                                                                <span class="addr-text"
                                                                    :title="(item.points && item.points[1] && item.points[1].address) || 'Endereço não informado'">
                                                                    {{ (item.points && item.points[1] &&
                                                                        item.points[1].address) || 'Endereço não informado'
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div class="meta">
                                                            <v-chip small outlined class="mr-2"
                                                                v-if="item.passenger.cost_center">
                                                                <v-icon left small>mdi-briefcase-account</v-icon>
                                                                {{ item.passenger.cost_center.name }}
                                                            </v-chip>

                                                            <v-chip small outlined class="mr-2" v-if="item.distance">
                                                                <v-icon left small>mdi-ruler</v-icon>
                                                                {{ convertDistanceOrDuration({
                                                                    distance: item.distance
                                                                }).distance }} km
                                                            </v-chip>

                                                            <v-chip small outlined class="ml-2" v-if="item.duration">
                                                                <v-icon left small>mdi-clock-outline</v-icon>
                                                                {{ convertDistanceOrDuration({
                                                                    duration: item.duration
                                                                }).duration }}
                                                            </v-chip>
                                                            <v-chip small outlined v-else class="ml-2">N/A</v-chip>
                                                        </div>
                                                    </div>
                                                </v-sheet>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </template>
                        </v-data-table>

                    </v-card-text>
                </v-card>
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- MODAL GERAR HORÁRIOS -->
        <v-dialog v-model="schedule.show" max-width="900px">
            <v-card>
                <v-card-title>Horários gerados</v-card-title>
                <v-card-subtitle class="pt-1">
                    Entrada: o carro chega na empresa até o horário menos a margem configurada na empresa,
                    contando a espera em cada embarque. Saída: o embarque é na empresa e o horário se mantém.
                </v-card-subtitle>
                <v-card-text>
                    <v-card v-for="vehicle in schedule.vehicles" :key="'sch-' + vehicle.vehicle_number" outlined class="mb-3">
                        <div class="px-4 pt-3 d-flex align-center flex-wrap">
                            <strong class="mr-3">Veículo {{ vehicle.vehicle_number }}</strong>
                            <template v-if="!vehicle.error">
                                <v-chip small class="mr-2">{{ vehicle.type | enum(dataset.tripTypes, 'id', 'name') }}</v-chip>
                                <span v-if="vehicle.type === 1" class="mr-3">Chegada até <b>{{ vehicle.arrival_target }}</b></span>
                                <span class="mr-3">Saída {{ vehicle.start_time }}</span>
                                <span class="mr-3 grey--text">{{ vehicle.travel_minutes }} min de deslocamento<span v-if="vehicle.distance_km"> · {{ vehicle.distance_km }} km</span></span>
                                <span class="grey--text">espera {{ vehicle.boarding_wait_minutes }} min/passageiro</span>
                                <v-chip v-if="vehicle.source === 'estimate'" x-small color="orange lighten-4" class="ml-2">tempo estimado em linha reta</v-chip>
                            </template>
                        </div>
                        <div v-if="vehicle.error" class="px-4 py-3 red--text text--darken-2">{{ vehicle.error }}</div>
                        <template v-else>
                            <div v-for="warning in vehicle.warnings" :key="warning" class="px-4 orange--text text--darken-3 text-caption">
                                <v-icon x-small color="orange darken-3">mdi-alert</v-icon> {{ warning }}
                            </div>
                            <v-simple-table dense class="mt-2">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Passageiro</th>
                                        <th>Solicitado</th>
                                        <th>Embarque atual</th>
                                        <th>Embarque gerado</th>
                                        <th>Chegada prevista</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="p in vehicle.passengers" :key="'sch-p-' + p.id">
                                        <td>{{ p.order || '-' }}</td>
                                        <td class="text-uppercase">{{ p.name }}</td>
                                        <td>{{ p.requested_time }}</td>
                                        <td>{{ currentBoarding(p.id) || '-' }}</td>
                                        <td><strong :class="{ 'primary--text': p.boarding_time !== currentBoarding(p.id) }">{{ p.boarding_time }}</strong></td>
                                        <td>{{ p.dropoff_eta || '-' }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </template>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="schedule.show = false">Fechar</v-btn>
                    <v-btn color="primary" elevation="0" @click="applySchedule"
                        :disabled="!schedule.vehicles.some(v => !v.error)">Aplicar horários</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL REVISAR VIAGENS -->
        <v-dialog v-model="showReviewModal" max-width="900px">
            <v-card>
                <v-card-title>
                    Revisar Viagens
                </v-card-title>

                <v-card-text class="py-4">
                    <p>Detalhes das viagens agrupadas por veículo e suas rotas no mapa:</p>

                    <div v-if="tripRoutesData.length === 0" class="text-center py-5">
                        <p>Nenhuma rota disponível para exibição. Verifique os dados das viagens.</p>
                    </div>
                    <div v-else>
                        <h3 class="mb-2">Rotas no Mapa:</h3>
                        <TripMap v-if="showReviewModal" ref="tripMapComponentRef" :passengers="tripRoutesData"
                            @routes-calculated="handleRoutesCalculated" />

                        <v-divider class="my-4"></v-divider>

                        <h3 class="mb-2">Detalhes:</h3>
                        <v-expansion-panels>
                            <v-expansion-panel v-for="(passengers, vehicleNum) in groupedTrips"
                                :key="`vehicle-${vehicleNum}`">
                                <v-expansion-panel-header class="py-2">
                                    <div class="d-flex align-center">
                                        <v-icon left class="mr-2">mdi-car</v-icon>
                                        <span class="font-weight-regular">
                                            Veículo {{ vehicleNum }}
                                        </span>
                                        <span class="ml-2 grey--text text--darken-1">
                                            ({{ passengers.length }} passageiro<span
                                                v-if="passengers.length > 1">s</span>)
                                        </span>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div class="itinerary-info mb-4">
                                        <!-- <strong>Itinerário:</strong> {{ getItineraryCompanies(passengers) }} -->
                                        <strong>Itinerário:</strong> <span
                                            v-html="getItineraryCompanies(passengers)"></span>
                                    </div>
                                    <v-list dense>
                                        <v-list-item v-for="(p, index) in passengers" :key="index">
                                            <v-list-item-content>
                                                <v-list-item-title class="text-uppercase mb-1">
                                                    <div :style="{ backgroundColor: routeColors[index % routeColors.length], border: '2px solid white' }"
                                                        class="custom-marker-icon"></div>
                                                    <br />

                                                    <v-icon small class="mr-2">mdi-account</v-icon>
                                                    {{ p.passenger.name }}

                                                </v-list-item-title>
                                                <div class="d-flex align-center text-caption mb-1">
                                                    <v-icon small class="mr-1">mdi-map-marker</v-icon>
                                                    <span class="font-weight-medium mr-1">Origem:</span> {{
                                                        p.points[0].address
                                                    }}
                                                </div>
                                                <div class="d-flex align-center text-caption mb-1">
                                                    <v-icon small class="mr-1">mdi-map-marker-check</v-icon>
                                                    <span class="font-weight-medium mr-1">Destino:</span> {{
                                                        p.points[1].address }}
                                                    <span class="ml-2 grey--text text--darken-1">
                                                        ({{ convertDistanceOrDuration({
                                                            distance:
                                                                p.distance
                                                        }).distance }} km)
                                                    </span>
                                                </div>
                                                <div class="d-flex align-center text-caption mb-1">
                                                    <v-icon small class="mr-1">mdi-clock-time-four-outline</v-icon>
                                                    <span class="font-weight-medium mr-1">Embarque:</span> {{
                                                        p.time }}
                                                </div>
                                                <div class="d-flex align-center text-caption">
                                                    <v-icon small class="mr-1">mdi-swap-horizontal</v-icon>
                                                    <span class="font-weight-medium mr-1">Tipo:</span> {{ p.type |
                                                    enum(dataset.tripTypes, 'id', 'name') }}
                                                </div>
                                                <!-- <div v-if="canViewTripAmounts" class="d-flex align-center text-caption">
                                                    <v-icon small class="mr-1">mdi-currency-usd</v-icon>
                                                    <span class="font-weight-medium mr-1">Valor:</span> {{ p.value ?
                                                        p.value.toLocaleString('pt-BR', {
                                                            style: 'currency', currency: 'BRL'
                                                        }) :
                                                        'N/A' }}
                                                </div> -->
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>

                                    <!-- <v-divider class="my-3"></v-divider>
                                    <div v-if="canViewTripAmounts" class="d-flex justify-end align-center px-4 py-2">
                                        <span class="font-weight-bold mr-2">Valor Total:</span>
                                        <span class="primary--text font-weight-bold">
                                            {{ calculateVehicleTotal(passengers).toLocaleString('pt-BR', {
                                                style:
                                                    'currency',
                                                currency: 'BRL'
                                            }) }}
                                        </span>
                                    </div> -->
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="showReviewModal = false">Fechar</v-btn>
                    <!-- <v-btn color="primary" @click="confirmTripReview">Confirmar Agendamento</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL CONFIRMAR ALTERAÇÕES -->
        <v-dialog v-model="dialogConfirmSave" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 primary--text">mdi-content-save-alert-outline</v-icon>
                    Confirmar Salvamento
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    Você tem certeza que deseja **salvar as alterações** nas atribuições de horário de embarque e
                    veículos?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" text @click="dialogConfirmSave = false">Cancelar</v-btn>
                    <v-btn color="primary" text @click="confirmSaveChanges">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogRequestDetails" max-width="600px">
            <v-card class='pa-3'>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h3 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Detalhes da solicitação
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row no-gutters>
                        <v-col>
                            <v-row>
                                <v-col>
                                    <v-row v-if="dataset.selectedRequest">
                                        <v-col>
                                            <br>
                                            <br>

                                            <p>Data/Hora: <strong> {{ dataset.selectedRequest.date |
                                                defaultDate('DD/MM/YYYY')
                                                    }} {{ dataset.selectedRequest.time }} </strong></p>

                                            <p class="text-uppercase">Nome completo: <strong> {{
                                                dataset.selectedRequest.passenger.name }} </strong></p>

                                            <p>Itinerario: <strong>{{ dataset.selectedRequest.itinerary_name || 'N/A'
                                                    }}</strong></p>

                                            <p>Solicitante: <strong>{{ dataset.selectedRequest.requester.name || 'N/A'
                                                    }}</strong>
                                            </p>


                                            <p>De: <strong>{{ dataset.selectedRequest.points[0].address || 'N/A'
                                                    }}</strong></p>

                                            <p v-for="stop in (dataset.selectedRequest.stops || [])"
                                                :key="`selected-stop-${stop.id}`">
                                                Parada {{ stop.position }}: <strong>{{ stop.address }}</strong>
                                                <span v-if="stop.observation"> ({{ stop.observation }})</span>
                                            </p>

                                            <p>Para: <strong>{{ dataset.selectedRequest.points[1].address || 'N/A'
                                                    }}</strong>
                                            </p>

                                            <p>Tipo de viagem: <strong>{{ dataset.selectedRequest.type |
                                                    enum(dataset.tripTypes,
                                                'id',
                                                'name')
                                                    }}</strong></p>

                                            <p>Motivo: <span v-if="dataset.selectedRequest.reason"><strong>
                                                        {{ parseInt(dataset.selectedRequest.reason) |
                                                        enum(dataset.reasonTypes,
                                                            'id',
                                                            'name')
                                                        }}</strong></span>
                                                <span v-else>N/A</span>
                                            </p>

                                            <p>Justificativa: <strong>{{ dataset.selectedRequest.justification ||
                                                'N/A' }}</strong></p>

                                            <p>Observação: <strong>{{ dataset.selectedRequest.observation ||
                                                'N/A' }}</strong></p>

                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                        </v-col>

                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary darken-1" text @click="dialogRequestDetails = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL RESETAR DADOS -->
        <v-dialog v-model="dialogConfirmReset" max-width="600px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 warning--text">mdi-delete-empty-outline</v-icon>
                    Confirmar Exclusão de Viagens
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    <p v-if="selectedItems.length > 0">
                        Você tem certeza que deseja **excluir as {{ selectedItems.length }} viagens selecionadas**? Esta
                        ação é
                        irreversível.
                    </p>
                    <p v-else>
                        Nenhuma viagem selecionada para exclusão. Por favor, selecione as viagens que deseja excluir na
                        tabela.
                    </p>

                    <v-list dense v-if="selectedItems.length > 0">
                        <v-list-item v-for="item in selectedItems" :key="item.id">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-icon small class="mr-1">mdi-account</v-icon> {{ item.passenger }}
                                    <span class="text-caption ml-2 grey--text">
                                        ({{ new Date(item.dateTime).toLocaleDateString('pt-BR') }} - {{
                                            item.boardingTime }})
                                    </span>
                                </v-list-item-title>
                                <v-list-item-subtitle class="d-flex align-center text-caption">
                                    <v-icon x-small class="mr-1">mdi-map-marker</v-icon> {{ item.address }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" text @click="cancelResetMode">Cancelar</v-btn>
                    <v-btn color="error darken-1" text @click="confirmResetData"
                        :disabled="selectedItems.length === 0">Excluir
                        Selecionadas</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAppendRequest" v-if="dataset.selectedTripRequest" max-width="600px">
            <v-card class='pa-3'>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h3 class="custom-modal-title text-uppercase black--text font-weight-bold mb-5">
                                Atribuir solicitação
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-form>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete dense outlined label="Viagens" :items="dataset.trips"
                                    :loading="dataset.tripLoading" class="mb-7" :search-input.sync="searchTrip"
                                    v-model="dataset.selectedTripRequest.trip_id" item-value="id" :filter="() => true"
                                    hide-details="auto" no-data-text="Nenhuma viagem encontrada">

                                    <template v-slot:item="{ item }">
                                        <div class="py-2">
                                            <strong>#{{ item.id }}</strong>
                                            </br>
                                            <span>{{ item.date | defaultDate('DD.MM') }} {{ item.time }} - {{
                                                item.itinerary || 'N/A'
                                                }} <strong>({{ item.type | enum(dataset.tripTypes, 'id', 'name')
                                                    }})</strong></span>
                                        </div>
                                    </template>

                                    <template v-slot:selection="{ item, index }">
                                        <div>
                                            <strong>#{{ item.id }}</strong> | <span>{{ item.date | defaultDate('DD.MM')
                                                }}
                                                {{ item.time }} <strong>({{ item.type | enum(dataset.tripTypes, 'id',
                                                    'name')
                                                    }})</strong></span>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-spacer></v-spacer>
                <v-card-actions>
                    <v-btn color="primary" @click="saveAppendRequest()" :loading="dataset.loading">Salvar</v-btn>
                    <v-btn color="grey darken-1" text @click="dialogAppendRequest = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import tripTypes from '@/common/data/trip-types.data';
import tripReasonTypes from '@/common/data/trip-reason-types.data';
import TripMap from '@/layouts/components/maps/LogisticMap.vue';
import axios from 'axios';

import debounce from 'lodash/debounce'

export default {
    name: 'LogisticsList',
    components: {
        TripMap,
    },
    data() {
        return {
            breadcrumbs: [
                { text: 'Home', disabled: false, to: '/home', exact: true },
                { text: 'Logística', disabled: true, exact: true },
            ],
            headers: [
                { text: 'Data', value: 'date', sortable: false, align: 'center' },
                { text: 'Tipo', value: 'type', sortable: false, align: 'center' },
                { text: 'Passageiro', value: 'passenger', sortable: false, align: 'center' },
                { text: 'Itinerário', value: 'itinerary', sortable: false, align: 'center' },
                { text: 'Solicitante', value: 'requester', sortable: false, align: 'center' },
                { text: 'Empresa', value: 'customer', sortable: false, align: 'center' },
                { text: 'Horário de embarque', value: 'time', sortable: false, align: 'center' },
                {
                    text: 'Veículo',
                    value: 'vehicle_number',
                    sortable: true,
                    align: 'center',
                    sort: (a, b) => {
                        const na = (a === null || a === undefined || a === '') ? Number.POSITIVE_INFINITY : Number(a)
                        const nb = (b === null || b === undefined || b === '') ? Number.POSITIVE_INFINITY : Number(b)
                        return na - nb
                    },
                },
                { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
            ],
            dataList: {
                data: [],
                loading: false,
                filter: {
                    neighborhoods: [],
                    cities: []
                },
                count: 0,
                options: {
                    page: 1,
                    size: 50,
                    itemsPerPage: 50,
                    sortBy: ['id'],
                    sortDesc: [false],
                },
                footerOptions: {
                    itemsPerPageText: 'Itens por página:',
                    itemsPerPageOptions: [10, 20, 30, 40, 50, 100],
                    pageText: '{0}-{1} de {2}',
                },
            },
            dataset: {
                tripTypes: tripTypes,
                reasonTypes: tripReasonTypes,
                selectedRequest: null,
                selectedTripRequest: null,
                trips: [],
                loading: false,
            },
            routeColors: [
                '#E91E63', '#2196F3', '#4CAF50', '#FFC107', '#9C27B0',
                '#FF5722', '#00BCD4', '#795548', '#607D8B', '#F44336',
            ],
            loading: false,
            totalItems: 0,
            options: {},
            showReviewModal: false,
            groupedTrips: {},
            tripRoutesData: [],
            calculatedDistances: {},
            dialogConfirmSave: false,
            dialogConfirmReset: false,
            dialogAppendRequest: false,
            itemsToSave: [],
            selectedItems: [],
            showSelectionCheckboxes: false,
            expandedIds: new Set(),
            dialogRequestDetails: false,
            pollingInterval: null,
            lastLoadAt: 0,
            isLoadingNow: false,

            searchTrip: '',

            schedule: {
                show: false,
                loading: false,
                vehicles: []
            }
        };
    },


    created() {
        this.loadInitialData()
        // this.startPolling()
    },

    // beforeDestroy() {
    //     this.stopPolling();
    //     document.removeEventListener('visibilitychange', this.onVisibilityChange);
    // },

    // mounted() {
    //     document.addEventListener('visibilitychange', this.onVisibilityChange);
    // },

    watch: {
        searchTrip(val) {
            this.loadTrips(val);
        },
    },

    computed: {
        canViewTripAmounts() {
            return this.$check(['trips.view.amount', 'logistics.view.amount']);
        },
    },

    methods: {

        pageSizeChanged(size) {
            console.log('size ', size)
            this.dataList.options.size = size;
            this.loadInitialData();
        },

        saveChanges() {
            this.dialogConfirmSave = true;
        },

        // Calcula o embarque de cada passageiro pelos carros montados na tabela
        async generateSchedule() {
            const items = this.dataList.data
                .filter(item => item.vehicle_number > 0)
                .map(item => ({ id: item.id, vehicle_number: item.vehicle_number }));

            this.schedule.loading = true;
            try {
                const response = await axios.post('/api/v2/logistics/schedule', { items });
                this.schedule.vehicles = response.data.content.vehicles;
                this.schedule.show = true;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.schedule.loading = false;
            }
        },

        currentBoarding(id) {
            const item = this.dataList.data.find(i => i.id === id);
            return item && item.boarding_time ? String(item.boarding_time).slice(0, 5) : null;
        },

        applySchedule() {
            let count = 0;

            for (const vehicle of this.schedule.vehicles) {
                if (vehicle.error) continue;

                for (const passenger of vehicle.passengers) {
                    const item = this.dataList.data.find(i => i.id === passenger.id);
                    if (!item || !passenger.boarding_time) continue;

                    this.$set(item, 'boarding_time', passenger.boarding_time);
                    count++;
                }
            }

            this.schedule.show = false;
            this.$dialog.notify.success(`${count} horários aplicados. Confira e clique em Salvar Alterações para criar as OS.`, { position: 'top-right', timeout: 5000 });
        },

        handleResetButtonClick() {
            if (this.showSelectionCheckboxes) {
                this.dialogConfirmReset = true;
            } else {
                this.showSelectionCheckboxes = true;
                this.selectedItems = [];
            }
        },

        openAppendTripDialog(item) {
            this.dataset.selectedTripRequest = item;
            this.dialogAppendRequest = true;
        },

        onOptionsChange(opts) {
            delete opts.itemsPerPage;

            this.dataList.options = { ...this.dataList.options, ...opts }
            const key = opts.sortBy[0]
            if (!key) return

            const desc = !!opts.sortDesc[0]

            const getVal = (it) => {
                if (key === 'vehicle_number') {
                    const v = it.vehicle_number
                    return (v === null || v === undefined || v === '') ? Number.POSITIVE_INFINITY : Number(v)
                }
                return it[key]
            }

            const cmp = (a, b) => {
                const va = getVal(a)
                const vb = getVal(b)
                if (va < vb) return -1
                if (va > vb) return 1
                return 0
            }

            const sorted = [...this.dataList.data].sort(cmp)
            this.dataList.data = desc ? sorted.reverse() : sorted
        },

        openInMaps(address) {
            if (!address) return
            const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
            window.open(url, "_blank")
        },

        normalizeTags(field) {
            const arr = (this.dataList.filter[field] || [])
                .map(v => (v || '').toString().trim())
                .filter(v => v.length > 0);

            const seen = new Set();
            const normalized = [];
            for (const v of arr) {
                const key = v.toLowerCase();
                if (!seen.has(key)) {
                    seen.add(key);
                    normalized.push(v);
                }
            }
            this.$set(this.dataList.filter, field, normalized);
        },

        cancelResetMode() {
            this.showSelectionCheckboxes = false;
            this.selectedItems = [];
            this.dialogConfirmReset = false;
        },

        // formatBoardingTime(item) {
        //     let value = item.boardingTime ? String(item.boardingTime).replace(/\D/g, '') : '';
        //     if (value.length > 4) {
        //         value = value.substring(0, 4);
        //     }

        //     if (value.length > 2) {
        //         item.boardingTime = `${value.substring(0, 2)}:${value.substring(2, 4)}`;
        //     } else {
        //         item.boardingTime = value;
        //     }
        // },

        validateBoardingTime(item) {
            const time = item.boarding_time;
            const regex = /^([01]\d|2[0-3]):?([0-5]\d)$/;
            if (time && !regex.test(time)) {
                this.$dialog.notify.error('Formato de horário inválido. Use HH:MM.', { position: 'top-right', timeout: 5000 });

            }
            if (time && time.length === 4 && /^\d{4}$/.test(time)) {
                item.boarding_time = `${time.substring(0, 2)}:${time.substring(2, 4)}`;
            }
        },

        validateVehicleNumber(item) {
            console.log('validate ', item)
            const value = item.vehicle_number;
            if (!value && value !== 0) return;

            const sameNumber = this.dataList.data.filter(i => i.vehicle_number === value);

            const conflict = sameNumber.some(i =>
                (i.id !== item.id) && (
                    i.date !== item.date || i.type !== item.type
                )
            );

            if (conflict) {

                this.$dialog.confirm({
                    text: `O veículo ${item.vehicle_number} já está atribuído a outro tipo nessa data (${sameNumber[0].date}). 
Cada número só pode ser usado para um único tipo de viagem no mesmo dia.`,
                    title: 'Aviso',
                    actions: {
                        true: 'OK'
                    }
                })

                // O valor digitado e mantido de proposito: limpar o campo aqui fazia
                // o numero sumir sem o operador perceber, e a viagem acabava salva
                // com um veiculo diferente do que ele tinha atribuido.
            }
        },

        convertDistanceOrDuration({ distance = null, duration = null } = {}) {
            const results = {};

            if (distance !== null) {
                results.distance = (distance / 1000).toFixed(1);
            }

            if (duration !== null) {
                const totalMinutes = Math.floor(duration / 60);
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                if (hours > 0 && minutes > 0) {
                    results.duration = `${hours}h ${minutes}min`;
                } else if (hours > 0) {
                    results.duration = `${hours}h`;
                } else {
                    results.duration = `${minutes}min`;
                }
            }

            return results;
        },

        openReviewModal() {
            this.calculatedDistances = {};
            this.groupedTrips = {};
            this.distance = [];

            this.tripRoutesData = this.dataList.data.map(item => ({
                id: item.id,
                passenger: item.passenger,
                itinerary_name: item.itinerary_name.toString().toUpperCase(),
                distance: `${this.convertDistanceOrDuration({
                    distance:
                        item.distance
                }).distance} km`,
                duration: `${this.convertDistanceOrDuration({
                    duration:
                        item.duration
                }).duration}`,
                pickup: { lat: item.points[0].latitude, lng: item.points[0].longitude, address: item.points[0].address },
                dropoff: { lat: item.points[1].latitude, lng: item.points[1].longitude, address: item.points[1].address },
                type: item.type,
                time: item.boarding_time,
                vehicle_number: item.vehicle_number,
                requester: item.requester,
            }));

            this.groupTripsByVehicle();
            this.showReviewModal = true;

            console.log('Botão Revisar Viagem clicado! Modal aberto.');
            console.log('Dados de rota preparados:', this.tripRoutesData);
        },


        handleRoutesCalculated(routeDetails) {
            console.log('Rotas calculadas recebidas do TripMap:', routeDetails);
            routeDetails.forEach(detail => {
                if (detail.passengerId && detail.distance !== null) {
                    this.$set(this.calculatedDistances, detail.passengerId, detail.distance);
                }
            });
        },

        getRouteDistance(passengerId) {
            return this.calculatedDistances[passengerId] || 'N/A';
        },


        incrementvehicleNumber(item) {
            item.vehicle_number = (item.vehicle_number || 0) + 1;
            this.logItemChange(item, 'vehicle_number');
        },
        decrementvehicleNumber(item) {
            if (item.vehicle_number && item.vehicle_number > 0) {
                item.vehicle_number--;
                this.logItemChange(item, 'vehicle_number');
            }
        },

        logItemChange(item, field) {
            console.log(`Campo '${field}' do item ID ${item.id} alterado para:`, item[field]);
        },

        groupTripsByVehicle() {
            const grouped = {};
            this.dataList.data.forEach(item => {
                const vehicleNum = item.vehicle_number > 0 ? item.vehicle_number : 'Não Atribuído';
                if (!grouped[vehicleNum]) {
                    grouped[vehicleNum] = [];
                }
                grouped[vehicleNum].push(item);
            });
            this.groupedTrips = Object.keys(grouped).sort((a, b) => {
                if (a === 'Não Atribuído') return 1;
                if (b === 'Não Atribuído') return -1;
                return parseInt(a) - parseInt(b);
            }).reduce((obj, key) => {
                obj[key] = grouped[key];
                return obj;
            }, {});
            console.log('Viagens agrupadas:', this.groupedTrips);
        },

        async loadData(force = false) {
            const now = Date.now();

            if (!force && this.lastLoadAt && (now - this.lastLoadAt) < 15000) return;

            if (this.isLoadingNow) return;

            this.isLoadingNow = true;
            try {
                await this.loadInitialData();
                this.lastLoadAt = Date.now();
            } finally {
                this.isLoadingNow = false;
            }
        },

        async loadInitialData() {
            this.dataList.loading = true;
            try {
                const response = await axios.get('/api/v2/trip-requests', { params: { limit: this.dataList.options.itemsPerPage, search: { ...this.dataList.filter } } });

                this.dataList.data = response.data.content.data;

                this.dataList.data = this.dataList.data.map((x) => {

                    if (x.type == 2) x.boarding_time = x.time;

                    return x;
                })

                this.dataList.count = response.data.content.total;

            } catch (error) {
                console.error('Erro ao carregar os dados da API:', error);
                // this.items = [];
                // this.totalItems = 0;
            } finally {
                this.dataList.loading = false;
            }
        },

        // Procura OS ja criadas que coincidem em data, tipo e horario com as
        // solicitacoes sendo salvas. Sem isso o operador cria uma OS nova sem
        // perceber que ja existe uma para o mesmo trajeto.
        async findMatchingTrips(items) {
            const encontrados = [];

            try {
                const result = await axios.get(`/api/v2/trips`, {
                    params: { start: 1, limit: 200, withoutRelationship: true, search: { status: 1 } }
                });

                const trips = result.data.content.data || [];

                for (const item of items) {
                    const trip = trips.find(t =>
                        t.date === item.date &&
                        Number(t.type) === Number(item.type) &&
                        (t.time || '').slice(0, 5) === (item.boarding_time || '').slice(0, 5)
                    );

                    if (trip) encontrados.push({ item, trip });
                }
            } catch (error) {
                // A checagem e um auxilio: se a busca falhar, segue o fluxo normal
                console.error('Erro ao procurar OS existentes:', error);
            }

            return encontrados;
        },

        loadTrips: debounce(async function (filter = '') {
            this.dataset.driverLoading = true;

            try {
                const result = await axios.get(`/api/v2/trips`, { params: { start: 1, limit: 50, withoutRelationship: true, search: { custom: filter, status: 1 } } });

                this.dataset.trips = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.driverLoading = false;
            }
        }, 1000),

        async confirmSaveChanges() {
            this.dialogConfirmSave = false;
            this.loading = true;

            try {
                let pendingItems = this.dataList.data.filter(item => item.vehicle_number && item.vehicle_number > 0);

                if (pendingItems.length === 0) {
                    this.$dialog.notify.error('Nenhuma viagem com veículo atribuído para salvar', { position: 'top-right', timeout: 5000 });
                    return;
                }

                const withoutBoardingTime = pendingItems.filter((x) => !x.boarding_time);

                if (withoutBoardingTime.length > 0) {
                    this.$dialog.notify.error('Algumas viagens estão sem horário de embarque. Por favor, revise antes de prosseguir', { position: 'top-right', timeout: 5000 });
                    return;
                }

                const existing = await this.findMatchingTrips(pendingItems);

                if (existing.length > 0) {
                    const linhas = existing
                        .map(e => `• ${e.item.passenger?.name || 'Passageiro'} (${e.item.boarding_time}) → OS #${e.trip.id}`)
                        .join('\n');

                    const juntar = await this.$dialog.confirm({
                        title: 'Já existe OS neste horário',
                        text: `Estas solicitações coincidem em data, tipo e horário com OS já criadas:\n\n${linhas}\n\nAdicionar os passageiros às OS existentes ou criar novas OS?`,
                        actions: {
                            false: 'Criar novas OS',
                            true: { text: 'Adicionar às existentes', color: 'primary' }
                        }
                    });

                    if (juntar) {
                        for (const e of existing) {
                            await axios.post(`/api/v2/trips/${e.trip.id}/append-request`, {
                                trip_request_id: e.item.id,
                                boarding_time: e.item.boarding_time,
                            });
                        }

                        const anexados = new Set(existing.map(e => e.item.id));
                        pendingItems = pendingItems.filter(item => !anexados.has(item.id));

                        if (pendingItems.length === 0) {
                            this.$dialog.notify.success("Passageiros adicionados às OS existentes!", { position: 'top-right', timeout: 3000 });
                            await this.loadInitialData();
                            return;
                        }
                    }
                }

                const dataToPatch = pendingItems.map(item => ({
                    id: item.id,
                    vehicle_number: item.vehicle_number,
                    time: item.boarding_time,
                }));

                const response = await axios.post('/api/v2/trips/bulk-requests', { items: dataToPatch });

                console.log('Resposta da API (Salvar):', response.data);

                this.$dialog.notify.success("Logística atualizada com sucesso!", { position: 'top-right', timeout: 3000 });

                await this.loadInitialData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
                console.error('Erro ao salvar alterações:', error.response ? error.response.data : error.message);
            } finally {
                this.loading = false;
            }
        },

        async saveAppendRequest() {
            this.dataset.loading = true;

            try {

                if (!this.dataset.selectedTripRequest.trip_id) {
                    this.$dialog.notify.error('Selecione uma viagem antes de prosseguir', { position: 'top-right', timeout: 5000 });
                    return;
                }

                if (!this.dataset.selectedTripRequest.boarding_time) {
                    this.$dialog.notify.error('Solicitação sem horário de embarque. Por favor, revise antes de prosseguir', { position: 'top-right', timeout: 5000 });
                    return;
                }

                const response = await axios.post(`/api/v2/trips/${this.dataset.selectedTripRequest.trip_id}/append-request`, {
                    trip_request_id: this.dataset.selectedTripRequest.id,
                    boarding_time: this.dataset.selectedTripRequest.boarding_time,
                });

                console.log('Resposta da API (Salvar):', response.data);

                this.$dialog.notify.success("Logística atualizada com sucesso!", { position: 'top-right', timeout: 3000 });

                await this.loadInitialData();

                this.dataset.selectedTripRequest = null;
                this.dialogAppendRequest = false;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
                console.error('Erro ao salvar alterações:', error.response ? error.response.data : error.message);
            } finally {
                this.dataset.loading = false;
            }
        },

        async confirmResetData() {
            if (this.selectedItems.length === 0) {
                alert('Por favor, selecione ao menos uma viagem para excluir.');
                return;
            }

            this.dialogConfirmReset = false;
            this.loading = true;

            try {
                const idsToDelete = this.selectedItems.map(item => item.id);
                console.log('IDs a serem excluídos:', idsToDelete);

                const response = await axios.delete('/api/pending-releases', { data: { ids: idsToDelete } });

                alert('Viagens selecionadas excluídas com sucesso!');
                this.selectedItems = [];
                this.loadInitialData();
            } catch (error) {
                console.error('Erro ao excluir dados:', error.response ? error.response.data : error.message);
            } finally {
                this.loading = false;
                this.showSelectionCheckboxes = false;
            }
        },

        calculateVehicleTotal(passengers) {
            if (!this.canViewTripAmounts) return 0;

            return passengers.reduce((total, passenger) => {
                const value = parseFloat(passenger.value);
                return total + (isNaN(value) ? 0 : value);
            }, 0);
        },

        getItineraryCompanies(passengers) {

        },

        openRequestDetails(item) {
            this.dataset.selectedRequest = item;
            this.dialogRequestDetails = true;
        },

        viewItem(item) {

        },

        // startPolling() {
        //     if (this.pollingInterval) return;

        //     this.pollingInterval = setInterval(() => {
        //         this.loadData();
        //     }, 20000);
        // },

        // stopPolling() {
        //     if (this.pollingInterval) {
        //         clearInterval(this.pollingInterval);
        //         this.pollingInterval = null;
        //     }
        // },

        // onVisibilityChange() {
        //     if (document.hidden) {
        //         this.stopPolling();
        //     } else {
        //         this.loadData(true);
        //         this.startPolling();
        //     }
        // },
    },
};
</script>

<style lang="css">
.v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content {
    box-shadow: none !important;
}

.custom-marker-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 12px;
}

.no-table-lines>>>.v-data-table__wrapper table thead tr>th,
.no-table-lines>>>.v-data-table__wrapper table tbody tr>td,
.no-table-lines>>>.v-data-table__wrapper table tbody tr>th {
    border-bottom: 0 !important;
}

.no-row-border>>>td {
    border-bottom: 0 !important;
}

/* bloco do footer */
.row-footer {
    background-color: #f4f4f4 !important;
    /* fundo leve */
    /* acento de cor (primária) */
    border-radius: 8px;
}

/* layout interno do footer */
.footer-grid {
    display: grid;
    grid-template-columns: 1fr auto;
    /* endereços | chips */
    grid-gap: 12px;
    align-items: center;
}

.addr-line:hover .addr-text,
.addr-line:hover .label {
    color: #1976d2;
    text-decoration: underline;
}

.addresses .addr-line {
    cursor: pointer;
    transition: color 0.2s ease;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    font-size: 13px;
}

.addresses .label {
    font-weight: 600;
    margin-right: 6px;
}

.addresses .addr-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

/* chips alinhados à direita e compactos */
.meta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

/* tirar hover cinza do Vuetify nas linhas */
.no-table-lines>>>.v-data-table__wrapper table tbody tr:hover>td {
    background: transparent !important;
}

.rot-180 {
    transform: rotate(180deg);
    transition: transform .2s;
}
</style>
